var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandwirtschaft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Landwirtschaft__Icn/40px/Legende/Landwirtschaft",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Landwirtschaft__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Landwirtschaft__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,10 L30.0006599,17.8898957 C31.5053954,18.8713124 32.5,20.569505 32.5,22.5 C32.5,25.5375661 30.0375661,28 27,28 C24.4825098,28 22.3600694,26.3085909 21.7070823,24.0001762 L16.4645627,24.0000497 C16.4879165,24.1633354 16.5,24.3302566 16.5,24.5 C16.5,26.4329966 14.9329966,28 13,28 C11.0670034,28 9.5,26.4329966 9.5,24.5 C9.5,23.8400859 9.68263439,23.2228284 10.0001155,22.696015 L10,15 L16,15 L16,12.0024341 L18,12.0024341 L18,15 L20,15 L20,10 L30,10 Z M13,23 C12.1715729,23 11.5,23.6715729 11.5,24.5 C11.5,25.3284271 12.1715729,26 13,26 C13.8284271,26 14.5,25.3284271 14.5,24.5 C14.5,23.6715729 13.8284271,23 13,23 Z M27,19 C25.0670034,19 23.5,20.5670034 23.5,22.5 C23.5,24.4329966 25.0670034,26 27,26 C28.9329966,26 30.5,24.4329966 30.5,22.5 C30.5,20.5670034 28.9329966,19 27,19 Z M28,12 L22,12 L22,17 L12,17 L12.0001626,21.1448909 C12.3169696,21.0506214 12.6525731,21 13,21 C13.9799843,21 14.8658991,21.4027597 15.5012456,22.0517804 L15.5,22 L21.5223861,22.0003933 C21.7748155,19.1969555 24.1308446,17 27,17 C27.3417786,17 27.676276,17.0311747 28.0008036,17.0908358 L28,12 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Landwirtschaft__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandwirtschaft);
export default __webpack_public_path__ + "static/media/Landwirtschaft.1422595beff404249132ead818aa9304.svg";
export { ForwardRef as ReactComponent };